import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild} from '@angular/core';
import {NotificationService} from '../../services/notification.service';
import {PriceTableChannelV2, PriceTableItemVM, PriceTableTargetTypeV2, PriceTableVM, ProductCatalogItemVM, ProductEditorSurfaceV2} from '../produtos-v2.models';
import {ProdutosV2FacadeService} from '../produtos-v2.facade';
import {TabelaPrecosService} from '../tabela-precos.service';
import {ViewDisponibilidadeComponent} from '../../compartilhado/view-disponibilidade/view-disponibilidade.component';
import {Router} from '@angular/router';

type PriceTableTab = 'produtos' | 'adicionais';
type CopyPriceOriginType = 'PADRAO' | 'TABELA';
type CopyPriceAdjustmentType = 'PERCENTUAL' | 'VALOR';
type CopyPriceAdjustmentOperation = 'AUMENTAR' | 'DIMINUIR';
type InitialPriceSeedMode = 'PADRAO_PRODUTOS' | 'COPIAR_TABELA' | 'VAZIA';

interface PriceTableLineVM {
  alvoId: number;
  tipoAlvo: PriceTableTargetTypeV2;
  nome: string;
  tipoLabel: string;
  item: PriceTableItemVM;
  precoPadrao: number | null;
  codigoPdv: string;
  categoriaId: number | null;
  categoriaNome: string;
  produtoId: number | null;
  produtoNome: string;
  adicionalNome: string;
  grupoAdicionalKey: string;
  imagem: string | null;
  placeholderToken: string;
  dirty?: boolean;
}

interface CopyPricePreviewLineVM {
  linha: PriceTableLineVM;
  valorAtual: number | null;
  valorOrigem: number | null;
  valorNovo: number | null;
  valorAtacadoAtual: number | null;
  valorAtacadoOrigem: number | null;
  valorAtacadoNovo: number | null;
  quantidadeAtual: number | null;
  quantidadeNova: number | null;
}

@Component({
  selector: 'app-tela-tabela-precos-v2',
  templateUrl: './tela-tabela-precos-v2.component.html',
  styleUrls: ['./tela-tabela-precos-v2.component.scss']
})
export class TelaTabelaPrecosV2Component implements OnChanges {
  @Input() empresa: any;
  @Input() modoPagina = false;
  @Input() produtosV2Ativo = false;
  @Output() closeRequested = new EventEmitter<void>();
  @Output() editarProdutoLegadoRequested = new EventEmitter<number>();
  @ViewChild(ViewDisponibilidadeComponent) viewDisponibilidade?: ViewDisponibilidadeComponent;

  loading = false;
  saving = false;
  tabelas: PriceTableVM[] = [];
  tabelaSelecionada: PriceTableVM | null = null;
  draft: PriceTableVM | null = null;
  tabelaDadosDraft: PriceTableVM | null = null;
  tabelaDadosModalOpen = false;
  search = '';
  codigoPdvFiltro = '';
  categoriaFiltroId: number | null = null;
  produtoFiltroId: number | null = null;
  grupoAdicionalFiltroKey: string | null = null;
  abaAtiva: PriceTableTab = 'produtos';
  itensTabela: PriceTableItemVM[] = [];
  linhasCatalogo: PriceTableLineVM[] = [];
  loadingItens = false;
  produtosCatalogo: ProductCatalogItemVM[] = [];
  produtosFiltroOpcoes: Array<{ id: number | null; nome: string }> = [];
  produtosFiltroOpcoesVisiveis: Array<{ id: number | null; nome: string }> = [];
  gruposAdicionaisFiltro: Array<{ key: string; nome: string; total: number }> = [];
  linhasFiltradasCache: PriceTableLineVM[] = [];
  linhasFiltradasPaginadasCache: PriceTableLineVM[] = [];
  totalPaginasCache = 1;
  inicioExibicaoCache = 0;
  fimExibicaoCache = 0;
  recalculandoLinhas = false;
  paginaAtual = 1;
  copiarPrecosModalOpen = false;
  copiaOrigemTipo: CopyPriceOriginType = 'PADRAO';
  copiaOrigemTabelaId: number | null = null;
  copiaOrigemValue = 'PADRAO';
  copiaPrecoUnitario = true;
  copiaPrecoAtacado = false;
  copiaOrigemItens: PriceTableItemVM[] = [];
  carregandoOrigemCopia = false;
  gerandoTabelaPadrao = false;
  copiaAjusteTipo: CopyPriceAdjustmentType = 'PERCENTUAL';
  copiaAjusteOperacao: CopyPriceAdjustmentOperation = 'AUMENTAR';
  copiaAjusteValor: number | null = null;
  drawerOpen = false;
  drawerProductId: number | null = null;
  drawerSurface: ProductEditorSurfaceV2 = 'overview';
  produtoAdicionaisModalOpen = false;
  produtoAdicionaisModalId: number | null = null;
  produtoAdicionaisModalNome = '';
  produtoAdicionaisModalImagem: string | null = null;
  grupoAdicionalModalFiltroKey: string | null = null;
  linhasAdicionaisProdutoModal: PriceTableLineVM[] = [];
  gruposAdicionaisProdutoModal: Array<{ key: string; nome: string; total: number }> = [];
  criacaoValoresIniciais: InitialPriceSeedMode = 'PADRAO_PRODUTOS';
  criacaoTabelaOrigemId: number | null = null;
  prioridadeHelpOpen = false;
  readonly itensPorPagina = 50;
  readonly limiteProdutosFiltro = 80;
  private grupoAdicionalIndice = new Map<string, number>();
  private totalAdicionaisPorProduto = new Map<number, number>();
  private atualizacaoLinhasTimer: any;

  readonly canais: Array<{ value: PriceTableChannelV2; text: string }> = [
    { value: 'LOJA', text: 'Loja' },
    { value: 'MESA', text: 'Mesa' },
    { value: 'BALCAO', text: 'Balcao' },
    { value: 'IFOOD', text: 'iFood' },
    { value: '99FOOD', text: '99Food' },
    { value: 'KEETA', text: 'Keeta' }
  ];

  constructor(
    private tabelaPrecosService: TabelaPrecosService,
    private facade: ProdutosV2FacadeService,
    private notificationService: NotificationService,
    private router: Router
  ) {}

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes['empresa'] && this.empresa?.catalogo?.id) {
      await this.carregue();
    }
  }

  async carregue(): Promise<void> {
    this.loading = true;
    try {
      this.tabelas = await this.tabelaPrecosService.listeTabelas(this.empresa.catalogo.id);
      if (!this.tabelas.length) {
        this.loading = false;
        await this.gereTabelaPadrao();
        return;
      }
      if (!this.tabelaSelecionada && this.tabelas.length) {
        await this.selecioneTabela(this.tabelas[0]);
      }
    } catch (e) {
      this.notificationService.showError(e);
    } finally {
      this.loading = false;
    }
  }

  async gereTabelaPadrao(): Promise<void> {
    if (this.gerandoTabelaPadrao || !this.empresa?.catalogo?.id) return;
    this.gerandoTabelaPadrao = true;
    try {
      const tabela = await this.tabelaPrecosService.gereTabelaPadrao(this.empresa.catalogo.id);
      this.tabelas = tabela ? [tabela] : [];
      if (tabela) await this.selecioneTabela(tabela);
    } catch (e) {
      this.notificationService.showError(e);
    } finally {
      this.gerandoTabelaPadrao = false;
    }
  }

  novaTabela(): void {
    this.tabelaDadosDraft = {
      nome: '',
      ativo: false,
      prioridade: 0,
      canal: null,
      suportaPrecosAtacado: false,
      disponibilidades: []
    };
    this.criacaoValoresIniciais = this.tabelas.length ? 'COPIAR_TABELA' : 'PADRAO_PRODUTOS';
    this.criacaoTabelaOrigemId = this.tabelas[0]?.id ? Number(this.tabelas[0].id) : null;
    this.tabelaDadosModalOpen = true;
  }

  async selecioneTabela(tabela: PriceTableVM): Promise<void> {
    this.tabelaSelecionada = tabela;
    this.draft = this.cloneTabela(tabela);
    this.paginaAtual = 1;
    await this.carregueItensTabela();
  }

  abraModalDadosTabela(): void {
    if (!this.draft) return;
    this.tabelaDadosDraft = this.cloneTabela(this.draft);
    this.tabelaDadosModalOpen = true;
  }

  fecheModalDadosTabela(): void {
    if (this.saving) return;
    this.tabelaDadosModalOpen = false;
    this.tabelaDadosDraft = null;
  }

  async salveTabela(): Promise<void> {
    const tabelaSalvar = this.tabelaDadosDraft || this.draft;
    if (!tabelaSalvar) return;
    const criandoTabela = !tabelaSalvar.id;
    const modoValoresIniciais = this.criacaoValoresIniciais;
    const tabelaOrigemId = this.criacaoTabelaOrigemId;

    if (criandoTabela && modoValoresIniciais === 'COPIAR_TABELA' && !tabelaOrigemId) {
      this.notificationService.showError('Selecione a tabela de origem ou crie sem valores iniciais.');
      return;
    }

    if (this.viewDisponibilidade) {
      tabelaSalvar.disponibilidades = this.viewDisponibilidade.disponibilidades || [];
    }
    this.saving = true;
    try {
      const salva = await this.tabelaPrecosService.salveTabela(tabelaSalvar, this.empresa.catalogo.id);
      const index = this.tabelas.findIndex((item) => item.id === salva.id);
      if (index >= 0) this.tabelas[index] = salva;
      else this.tabelas.unshift(salva);
      await this.selecioneTabela(salva);
      if (criandoTabela)
        await this.apliqueValoresIniciaisTabelaCriada(salva, modoValoresIniciais, tabelaOrigemId);
      this.tabelaDadosModalOpen = false;
      this.tabelaDadosDraft = null;
      this.notificationService.showSuccess('Tabela de precos salva.');
    } catch (e) {
      this.notificationService.showError(e);
    } finally {
      this.saving = false;
    }
  }

  async ativeTabelaSelecionada(): Promise<void> {
    if (!this.draft?.id || this.saving) return;
    this.saving = true;
    try {
      const salva = await this.tabelaPrecosService.salveTabela({...this.draft, ativo: true}, this.empresa.catalogo.id);
      const index = this.tabelas.findIndex((item) => item.id === salva.id);
      if (index >= 0) this.tabelas[index] = salva;
      await this.selecioneTabela(salva);
      this.notificationService.showSuccess('Tabela ativada.');
    } catch (e) {
      this.notificationService.showError(e);
    } finally {
      this.saving = false;
    }
  }

  async removaTabela(tabela: PriceTableVM): Promise<void> {
    if (!tabela.id) return;
    if (!confirm(`Remover a tabela "${tabela.nome}"?`)) return;
    try {
      await this.tabelaPrecosService.removaTabela(tabela);
      this.tabelas = this.tabelas.filter((item) => item.id !== tabela.id);
      this.tabelaSelecionada = null;
      this.draft = null;
      this.tabelaDadosModalOpen = false;
      this.tabelaDadosDraft = null;
      this.linhasCatalogo = [];
      this.atualizeIndiceGruposAdicionais();
      this.atualizeLinhasFiltradas();
    } catch (e) {
      this.notificationService.showError(e);
    }
  }

  async carregueItensTabela(): Promise<void> {
    if (!this.tabelaSelecionada?.id) return;
    this.loadingItens = true;
    try {
      const [catalogo, itens] = await Promise.all([
        this.facade.carregueCatalogo(this.empresa),
        this.tabelaPrecosService.listeItens(this.tabelaSelecionada.id)
      ]);
      this.itensTabela = itens || [];
      this.produtosCatalogo = catalogo || [];
      this.produtosFiltroOpcoes = this.monteProdutosFiltro();
      this.filtreProdutosFiltro('');
      this.linhasCatalogo = this.monteLinhasCatalogo(this.produtosCatalogo);
      this.atualizeGruposAdicionaisFiltro();
      this.atualizeIndiceGruposAdicionais();
      this.atualizeLinhasFiltradas();
    } catch (e) {
      this.notificationService.showError(e);
    } finally {
      this.loadingItens = false;
    }
  }

  marqueLinhaAlterada(linha: any): void {
    linha.dirty = true;
  }

  async salveItensAlterados(): Promise<void> {
    if (!this.tabelaSelecionada?.id) return;
    const alterados = this.linhasCatalogo.filter((linha) => linha.dirty).map((linha) => linha.item);
    if (!alterados.length) return;
    if (this.existemLinhasAtacadoInvalidas) {
      this.notificationService.showError('Informe quantidade mínima maior que 1 para preços de atacado.');
      return;
    }
    if (this.existemLinhasDescontoInvalidas) {
      this.notificationService.showError('Informe desconto maior ou igual a zero e menor ou igual ao preço unitário.');
      return;
    }
    if (this.existemLinhasPrecoInvalidas) {
      this.notificationService.showError('Informe preço unitário obrigatório e maior ou igual a zero.');
      return;
    }
    if (this.existemLinhasPrecoAtacadoInvalidas) {
      this.notificationService.showError('Informe preço atacado menor que o preço varejo.');
      return;
    }
    this.saving = true;
    try {
      await this.tabelaPrecosService.salveItens(this.tabelaSelecionada.id, alterados);
      this.notificationService.showSuccess('Precos salvos.');
      await this.carregueItensTabela();
    } catch (e) {
      this.notificationService.showError(e);
    } finally {
      this.saving = false;
    }
  }

  async abraModalCopiarPrecos(): Promise<void> {
    if (!this.tabelaSelecionada?.id) return;
    this.copiarPrecosModalOpen = true;
    this.copiaOrigemTipo = 'PADRAO';
    this.copiaOrigemTabelaId = null;
    this.copiaOrigemValue = 'PADRAO';
    this.copiaPrecoUnitario = true;
    this.copiaPrecoAtacado = false;
    this.copiaOrigemItens = [];
    this.copiaAjusteTipo = 'PERCENTUAL';
    this.copiaAjusteOperacao = 'AUMENTAR';
    this.copiaAjusteValor = null;
  }

  fecheModalCopiarPrecos(): void {
    if (this.saving || this.carregandoOrigemCopia) return;
    this.copiarPrecosModalOpen = false;
  }

  async onCopiaOrigemChange(value: string): Promise<void> {
    this.copiaOrigemValue = value;
    this.copiaOrigemItens = [];
    this.copiaPrecoAtacado = false;

    if (value === 'PADRAO') {
      this.copiaOrigemTipo = 'PADRAO';
      this.copiaOrigemTabelaId = null;
      this.copiaPrecoUnitario = true;
      return;
    }

    this.copiaOrigemTipo = 'TABELA';
    this.copiaOrigemTabelaId = Number(value);
    this.copiaPrecoUnitario = true;

    if (!this.copiaOrigemTabelaId) return;
    this.carregandoOrigemCopia = true;
    try {
      this.copiaOrigemItens = await this.tabelaPrecosService.listeItens(this.copiaOrigemTabelaId);
    } catch (e) {
      this.notificationService.showError(e);
    } finally {
      this.carregandoOrigemCopia = false;
    }
  }

  async copiePrecos(): Promise<void> {
    if (!this.tabelaSelecionada?.id || !this.podeConfirmarCopia) return;
    const itens = this.itensParaCopia;
    if (!itens.length) return;

    this.saving = true;
    try {
      await this.tabelaPrecosService.salveItens(this.tabelaSelecionada.id, itens);
      this.notificationService.showSuccess(`${itens.length} preços copiados.`);
      this.copiarPrecosModalOpen = false;
      await this.carregueItensTabela();
    } catch (e) {
      this.notificationService.showError(e);
    } finally {
      this.saving = false;
    }
  }

  get disponibilidadesCatalogo(): any[] {
    return this.empresa?.catalogo?.disponibilidades || [];
  }

  get categoriasFiltro(): any[] {
    return this.empresa?.catalogo?.categorias || [];
  }

  get linhasFiltradas(): PriceTableLineVM[] {
    return this.linhasFiltradasCache;
  }

  get linhasFiltradasPaginadas(): PriceTableLineVM[] {
    return this.linhasFiltradasPaginadasCache;
  }

  get totalPaginas(): number {
    return this.totalPaginasCache;
  }

  get paginasVisiveis(): Array<number | null> {
    const total = this.totalPaginas;
    const atual = Math.min(this.paginaAtual, total);
    if (total <= 5) return Array.from({ length: total }, (_item, index) => index + 1);
    if (atual <= 3) return [1, 2, 3, null, total];
    if (atual >= total - 2) return [1, null, total - 2, total - 1, total];
    return [1, null, atual - 1, atual, atual + 1, null, total];
  }

  get inicioExibicao(): number {
    return this.inicioExibicaoCache;
  }

  get fimExibicao(): number {
    return this.fimExibicaoCache;
  }

  get tabelasConfiguradasLabel(): string {
    const total = this.tabelas.length;
    return `${total} ${total === 1 ? 'tabela configurada' : 'tabelas configuradas'}`;
  }

  get opcoesOrigemCopia(): Array<{ value: string; text: string }> {
    const opcoes = [{ value: 'PADRAO', text: 'Preços padrão produtos' }];
    const destinoId = Number(this.tabelaSelecionada?.id || 0);
    this.tabelas
      .filter((tabela) => tabela.id && Number(tabela.id) !== destinoId)
      .forEach((tabela) => opcoes.push({ value: String(tabela.id), text: tabela.nome }));
    return opcoes;
  }

  get tabelasParaCopiaCriacao(): PriceTableVM[] {
    return this.tabelas.filter((tabela) => !!tabela.id);
  }

  get tabelaOrigemCopia(): PriceTableVM | null {
    if (this.copiaOrigemTipo !== 'TABELA' || !this.copiaOrigemTabelaId) return null;
    return this.tabelas.find((tabela) => Number(tabela.id) === Number(this.copiaOrigemTabelaId)) || null;
  }

  get podeCopiarAtacado(): boolean {
    return this.copiaOrigemTipo === 'TABELA'
      && !!this.tabelaOrigemCopia?.suportaPrecosAtacado
      && !!this.draft?.suportaPrecosAtacado;
  }

  get mensagemAtacadoIndisponivel(): string {
    if (this.copiaOrigemTipo === 'PADRAO') return 'Preços padrão não possuem atacado.';
    if (!this.tabelaOrigemCopia?.suportaPrecosAtacado) return 'A tabela origem não possui atacado.';
    if (!this.draft?.suportaPrecosAtacado) return 'A tabela destino não possui atacado.';
    return '';
  }

  get itensParaCopia(): PriceTableItemVM[] {
    if (!this.tabelaSelecionada?.id || (!this.copiaPrecoUnitario && !this.copiaPrecoAtacado)) return [];
    return this.monteItensParaCopia();
  }

  get copiaPreview(): CopyPricePreviewLineVM[] {
    return this.montePreviewCopia().slice(0, 8);
  }

  get copiaTotalProdutos(): number {
    return this.montePreviewCopia().filter((item) => item.linha.tipoAlvo !== 'OPCAO_ADICIONAL').length;
  }

  get copiaTotalAdicionais(): number {
    return this.montePreviewCopia().filter((item) => item.linha.tipoAlvo === 'OPCAO_ADICIONAL').length;
  }

  get podeConfirmarCopia(): boolean {
    return !this.carregandoOrigemCopia
      && !this.saving
      && this.itensParaCopia.length > 0
      && (this.copiaPrecoUnitario || this.copiaPrecoAtacado);
  }

  get copiaExemploOrigem(): number {
    return 10;
  }

  get copiaExemploAjustado(): number {
    return this.apliqueAjustePreco(this.copiaExemploOrigem);
  }

  get quantidadeAlteracoesPrecos(): number {
    return this.linhasCatalogo.filter((linha) => linha.dirty).length;
  }

  get existemLinhasAtacadoInvalidas(): boolean {
    return this.linhasCatalogo.some((linha) => linha.dirty && this.linhaAtacadoInvalida(linha));
  }

  get existemLinhasDescontoInvalidas(): boolean {
    return this.linhasCatalogo.some((linha) => linha.dirty && this.linhaDescontoInvalida(linha));
  }

  get existemLinhasPrecoInvalidas(): boolean {
    return this.linhasCatalogo.some((linha) => linha.dirty && this.linhaPrecoInvalida(linha));
  }

  get existemLinhasPrecoAtacadoInvalidas(): boolean {
    return this.linhasCatalogo.some((linha) => linha.dirty && this.linhaPrecoAtacadoInvalido(linha));
  }

  get salvarAlteracoesLabel(): string {
    if (!this.tabelaSelecionada?.id) return 'Salvar alterações';
    const total = this.quantidadeAlteracoesPrecos;
    if (!total) return 'Salvar alterações';
    return `Salvar alterações (${total})`;
  }

  get precoUnitarioLabel(): string {
    return this.draft?.suportaPrecosAtacado ? 'Preço varejo' : 'Preço unitário';
  }

  nomeItemTabela(linha: PriceTableLineVM, aba: PriceTableTab = this.abaAtiva, ocultarGrupoAdicional = false): string {
    if (aba !== 'adicionais') return linha.nome;
    if (ocultarGrupoAdicional) {
      const partes = String(linha.nome || '').split(':');
      return (partes.length > 1 ? partes.slice(1).join(':') : linha.nome).replace(/^:+\s*/, '').trim();
    }
    return String(linha.nome || '').replace(':', ' >');
  }

  subtituloItemTabela(linha: PriceTableLineVM, aba: PriceTableTab = this.abaAtiva): string {
    if (aba === 'adicionais')
      return `${linha.produtoNome || 'Sem produto'} / #${linha.alvoId}`;
    return `${linha.categoriaNome || 'Sem categoria'} / #${linha.alvoId}`;
  }

  get podeSalvarAlteracoes(): boolean {
    if (this.saving) return false;
    if (!this.tabelaSelecionada?.id) return false;
    return this.quantidadeAlteracoesPrecos > 0
      && !this.existemLinhasAtacadoInvalidas
      && !this.existemLinhasDescontoInvalidas
      && !this.existemLinhasPrecoInvalidas
      && !this.existemLinhasPrecoAtacadoInvalidas;
  }

  get quantidadeLinhasProdutos(): number {
    return this.linhasCatalogo.filter((linha) => linha.tipoAlvo === 'PRODUTO' || linha.tipoAlvo === 'PRODUTO_TAMANHO').length;
  }

  get quantidadeLinhasAdicionais(): number {
    return this.linhasCatalogo.filter((linha) => linha.tipoAlvo === 'OPCAO_ADICIONAL').length;
  }

  altereAba(aba: PriceTableTab): void {
    this.abaAtiva = aba;
    this.paginaAtual = 1;
    this.limpeFiltros();
    this.agendeAtualizacaoLinhasFiltradas();
  }

  limpeFiltros(): void {
    this.search = '';
    this.codigoPdvFiltro = '';
    this.categoriaFiltroId = null;
    this.produtoFiltroId = null;
    this.grupoAdicionalFiltroKey = null;
    this.gruposAdicionaisFiltro = [];
  }

  onCategoriaFiltroChange(): void {
    this.paginaAtual = 1;
    this.atualizeLinhasFiltradas();
  }

  onCodigoPdvFiltroChange(): void {
    this.paginaAtual = 1;
    this.atualizeLinhasFiltradas();
  }

  onBuscaFiltroChange(): void {
    this.paginaAtual = 1;
    this.atualizeLinhasFiltradas();
  }

  apliqueFiltros(): void {
    this.paginaAtual = 1;
    this.atualizeLinhasFiltradas();
  }

  async apliquePrecosPadrao(): Promise<void> {
    if (!this.tabelaSelecionada?.id) return;
    const linhas = this.linhasFiltradas.filter((linha) => linha.precoPadrao != null);
    if (!linhas.length) return;

    const tipo = this.abaAtiva === 'produtos' ? 'produtos' : 'adicionais';
    if (!confirm(`Serão salvos ${linhas.length} preços de ${tipo} na tabela, confirma essa operação?`))
      return;

    this.saving = true;
    try {
      const itens = linhas.map((linha) => ({
        tabelaDePrecosId: this.tabelaSelecionada!.id!,
        tipoAlvo: linha.tipoAlvo,
        alvoId: linha.alvoId,
        precoPadrao: linha.precoPadrao
      }));
      await this.tabelaPrecosService.apliquePrecosPadrao(this.tabelaSelecionada.id, itens);
      this.notificationService.showSuccess('Preços padrão aplicados.');
      await this.carregueItensTabela();
    } catch (e) {
      this.notificationService.showError(e);
    } finally {
      this.saving = false;
    }
  }

  canaisValue(tabela: PriceTableVM | null): PriceTableChannelV2[] {
    return this.normalizeCanais(tabela?.canais || tabela?.canal);
  }

  onCanaisChange(value: PriceTableChannelV2[]): void {
    const tabela = this.tabelaDadosDraft || this.draft;
    if (!tabela) return;
    const canais = this.normalizeCanais(value);
    tabela.canais = canais;
    tabela.canal = canais.length ? canais.join(',') : null;
  }

  canalLabel(canal: string | null): string {
    const canais = this.normalizeCanais(canal);
    return canais.length
      ? canais.map((canalTabela) => this.canais.find((item) => item.value === canalTabela)?.text || canalTabela).join(', ')
      : 'Todos';
  }

  tabelaDisponivelAgora(tabela: PriceTableVM): boolean {
    const disponibilidades = this.obtenhaDisponibilidadesTabela(tabela);
    if (!disponibilidades.length) return true;
    return disponibilidades.some((disponibilidade) => this.disponibilidadeEstaDisponivelAgora(disponibilidade));
  }

  cardIcon(index: number): string {
    return ['fa-shopping-bag', 'fa-motorcycle', 'fa-building', 'fa-calendar'][index % 4];
  }

  cardTone(index: number): string {
    return ['is-blue', 'is-amber', 'is-cyan', 'is-purple'][index % 4];
  }

  vaParaPagina(pagina: number): void {
    this.paginaAtual = Math.min(Math.max(1, pagina), this.totalPaginas);
    this.atualizePaginacaoLinhasFiltradas();
  }

  onCopiaAtacadoChange(value: boolean): void {
    this.copiaPrecoAtacado = this.podeCopiarAtacado ? value : false;
  }

  ajusteOperacaoSinal(): string {
    return this.copiaAjusteOperacao === 'AUMENTAR' ? '+' : '-';
  }

  onProdutoFiltroChange(value: any): void {
    const id = value && typeof value === 'object' ? value.id : value;
    this.produtoFiltroId = id ? Number(id) : null;
    this.grupoAdicionalFiltroKey = null;
    this.atualizeGruposAdicionaisFiltro();
    this.paginaAtual = 1;
    this.atualizeLinhasFiltradas();
  }

  selecioneGrupoAdicionalFiltro(grupoKey: string | null): void {
    this.grupoAdicionalFiltroKey = grupoKey;
    this.paginaAtual = 1;
    this.atualizeLinhasFiltradas();
  }

  trackByLinha(_index: number, linha: PriceTableLineVM): string {
    return `${linha.tipoAlvo}:${linha.alvoId}`;
  }

  filtreProdutosFiltro(termo: string): void {
    const filtro = String(termo || '').trim().toLowerCase();
    const opcoes = !filtro
      ? this.produtosFiltroOpcoes
      : this.produtosFiltroOpcoes.filter((produto) => produto.nome.toLowerCase().includes(filtro));
    this.produtosFiltroOpcoesVisiveis = opcoes.slice(0, this.limiteProdutosFiltro);
  }

  linhaTemDesconto(linha: PriceTableLineVM): boolean {
    return Number(linha?.item?.valor || 0) > 0 && Number(linha?.item?.desconto || 0) > 0;
  }

  obtenhaPrecoFinal(linha: PriceTableLineVM): number {
    const valor = Number(linha?.item?.valor || 0);
    const desconto = Number(linha?.item?.desconto || 0);
    return Number(Math.max(0, valor - desconto).toFixed(2));
  }

  obtenhaPercentualDesconto(linha: PriceTableLineVM): number {
    const valor = Number(linha?.item?.valor || 0);
    const desconto = Number(linha?.item?.desconto || 0);
    if (!valor || !desconto) return 0;
    return Number(((desconto / valor) * 100).toFixed(1));
  }

  abraEditorProduto(linha: PriceTableLineVM, event?: Event): void {
    if (event) event.stopPropagation();
    if (!linha?.produtoId) return;

    if (!this.produtosV2Ativo) {
      const produtoId = Number(linha.produtoId);
      if (this.modoPagina) {
        this.router.navigateByUrl(`/admin/produtos/${produtoId}`);
        return;
      }
      this.editarProdutoLegadoRequested.emit(produtoId);
      return;
    }

    this.drawerProductId = Number(linha.produtoId);
    this.drawerSurface = 'overview';
    this.drawerOpen = true;
  }

  async onDrawerClosed(): Promise<void> {
    this.drawerOpen = false;
    this.drawerProductId = null;
    await this.carregueItensTabela();
  }

  linhaAtacadoInvalida(linha: PriceTableLineVM): boolean {
    return !!this.draft?.suportaPrecosAtacado
      && this.temValor(linha.item.valorAtacado)
      && Number(linha.item.quantidadeMinimaAtacado || 0) <= 1;
  }

  linhaDescontoInvalida(linha: PriceTableLineVM): boolean {
    if (!this.temValor(linha?.item?.desconto)) return false;
    const desconto = Number(linha.item.desconto);
    if (isNaN(desconto) || desconto < 0) return true;
    if (desconto === 0) return false;
    const valor = Number(linha.item.valor);
    return isNaN(valor) || valor <= 0 || desconto > valor;
  }

  linhaPrecoInvalida(linha: PriceTableLineVM): boolean {
    if (!this.temValor(linha?.item?.valor)) return true;
    const valor = Number(linha.item.valor);
    return isNaN(valor) || valor < 0;
  }

  linhaPrecoAtacadoInvalido(linha: PriceTableLineVM): boolean {
    if (!this.draft?.suportaPrecosAtacado || !this.temValor(linha?.item?.valorAtacado)) return false;
    const valorAtacado = Number(linha.item.valorAtacado);
    const valor = Number(linha.item.valor);
    return isNaN(valorAtacado) || valorAtacado < 0 || isNaN(valor) || valorAtacado >= valor;
  }

  classeGrupoAdicional(linha: PriceTableLineVM, aba: PriceTableTab = this.abaAtiva): string {
    if (aba !== 'adicionais' || !linha.grupoAdicionalKey) return '';
    return (this.grupoAdicionalIndice.get(linha.grupoAdicionalKey) || 0) % 2 === 0
      ? 'is-additional-group-a'
      : 'is-additional-group-b';
  }

  produtoTemAdicionais(linha: PriceTableLineVM): boolean {
    return !!linha.produtoId && (this.totalAdicionaisPorProduto.get(Number(linha.produtoId)) || 0) > 0;
  }

  abraModalAdicionaisProduto(linha: PriceTableLineVM, event?: Event): void {
    if (event) event.stopPropagation();
    if (!linha?.produtoId || !this.produtoTemAdicionais(linha)) return;
    this.produtoAdicionaisModalId = Number(linha.produtoId);
    this.produtoAdicionaisModalNome = linha.produtoNome || linha.nome;
    this.produtoAdicionaisModalImagem = linha.imagem;
    this.gruposAdicionaisProdutoModal = this.obtenhaGruposAdicionaisProduto(this.produtoAdicionaisModalId);
    this.grupoAdicionalModalFiltroKey = this.gruposAdicionaisProdutoModal[0]?.key || null;
    this.atualizeLinhasAdicionaisProdutoModal();
    this.produtoAdicionaisModalOpen = true;
  }

  fecheModalAdicionaisProduto(): void {
    if (this.saving) return;
    this.produtoAdicionaisModalOpen = false;
    this.produtoAdicionaisModalId = null;
    this.produtoAdicionaisModalNome = '';
    this.produtoAdicionaisModalImagem = null;
    this.grupoAdicionalModalFiltroKey = null;
    this.linhasAdicionaisProdutoModal = [];
    this.gruposAdicionaisProdutoModal = [];
  }

  selecioneGrupoAdicionalModal(grupoKey: string | null): void {
    this.grupoAdicionalModalFiltroKey = grupoKey;
    this.atualizeLinhasAdicionaisProdutoModal();
  }

  async descarteAlteracoes(): Promise<void> {
    if (this.tabelaSelecionada) {
      this.draft = this.cloneTabela(this.tabelaSelecionada);
      await this.carregueItensTabela();
      return;
    }

    this.draft = null;
    this.linhasCatalogo = [];
    this.atualizeIndiceGruposAdicionais();
    this.atualizeLinhasFiltradas();
  }

  async salveAlteracoes(): Promise<void> {
    if (!this.draft) return;
    await this.salveItensAlterados();
  }

  private cloneTabela(tabela: PriceTableVM): PriceTableVM {
    const canais = this.normalizeCanais(tabela.canais || tabela.canal);
    return {
      ...tabela,
      canais,
      canal: canais.length ? canais.join(',') : null,
      disponibilidades: [...(tabela.disponibilidades || [])]
    };
  }

  private normalizeCanais(canais: any): PriceTableChannelV2[] {
    if (!canais || canais === 'TODOS') return [];
    const lista = Array.isArray(canais) ? canais : String(canais).split(',');
    return Array.from(new Set(lista
      .map((canal) => String(canal || '').trim())
      .filter((canal) => !!canal && canal !== 'TODOS')
      .map((canal) => this.normalizeCanal(canal))));
  }

  private normalizeCanal(canal: string): PriceTableChannelV2 {
    if (canal === 'DELIVERY' || canal === 'RETIRADA' || canal === 'RETIRADA_BALCAO') return 'LOJA';
    return canal as PriceTableChannelV2;
  }

  private monteProdutosFiltro(): Array<{ id: number | null; nome: string }> {
    return this.produtosCatalogo
      .filter((produto) => !!produto.id)
      .map((produto) => ({ id: Number(produto.id), nome: produto.name }))
      .sort((a, b) => a.nome.localeCompare(b.nome));
  }

  private atualizeGruposAdicionaisFiltro(): void {
    if (this.abaAtiva !== 'adicionais' || !this.produtoFiltroId) {
      this.gruposAdicionaisFiltro = [];
      return;
    }
    this.gruposAdicionaisFiltro = this.obtenhaGruposAdicionaisProduto(this.produtoFiltroId);
  }

  private obtenhaGruposAdicionaisProduto(produtoId: number): Array<{ key: string; nome: string; total: number }> {
    const grupos = new Map<string, { key: string; nome: string; total: number }>();
    this.linhasCatalogo
      .filter((linha) => linha.tipoAlvo === 'OPCAO_ADICIONAL'
        && Number(linha.produtoId) === Number(produtoId)
        && !!linha.grupoAdicionalKey)
      .forEach((linha) => {
        const nome = String(linha.nome || '').split(':')[0] || 'Adicional';
        const grupo = grupos.get(linha.grupoAdicionalKey) || { key: linha.grupoAdicionalKey, nome, total: 0 };
        grupo.total++;
        grupos.set(linha.grupoAdicionalKey, grupo);
      });
    return Array.from(grupos.values());
  }

  private atualizeLinhasAdicionaisProdutoModal(): void {
    if (!this.produtoAdicionaisModalId) {
      this.linhasAdicionaisProdutoModal = [];
      return;
    }

    this.linhasAdicionaisProdutoModal = this.linhasCatalogo.filter((linha) =>
      linha.tipoAlvo === 'OPCAO_ADICIONAL'
      && Number(linha.produtoId) === Number(this.produtoAdicionaisModalId)
      && (!this.grupoAdicionalModalFiltroKey || linha.grupoAdicionalKey === this.grupoAdicionalModalFiltroKey));
  }

  private atualizeLinhasFiltradas(): void {
    if (this.atualizacaoLinhasTimer) {
      clearTimeout(this.atualizacaoLinhasTimer);
      this.atualizacaoLinhasTimer = null;
    }
    const term = String(this.search || '').trim().toLowerCase();
    const codigoPdv = String(this.codigoPdvFiltro || '').trim().toLowerCase();

    this.linhasFiltradasCache = this.linhasCatalogo.filter((linha) => {
      if (this.abaAtiva === 'produtos') {
        if (linha.tipoAlvo !== 'PRODUTO' && linha.tipoAlvo !== 'PRODUTO_TAMANHO')
          return false;
        if (this.categoriaFiltroId && Number(linha.categoriaId) !== Number(this.categoriaFiltroId))
          return false;
        if (codigoPdv && !String(linha.codigoPdv || '').toLowerCase().includes(codigoPdv))
          return false;
      } else {
        if (linha.tipoAlvo !== 'OPCAO_ADICIONAL')
          return false;
        if (this.produtoFiltroId && Number(linha.produtoId) !== Number(this.produtoFiltroId))
          return false;
        if (this.grupoAdicionalFiltroKey && linha.grupoAdicionalKey !== this.grupoAdicionalFiltroKey)
          return false;
      }

      if (term
        && !linha.nome.toLowerCase().includes(term)
        && !linha.tipoLabel.toLowerCase().includes(term)
        && !linha.categoriaNome.toLowerCase().includes(term))
        return false;

      return true;
    });

    this.totalPaginasCache = Math.max(1, Math.ceil(this.linhasFiltradasCache.length / this.itensPorPagina));
    this.paginaAtual = Math.min(this.paginaAtual, this.totalPaginasCache);
    this.atualizePaginacaoLinhasFiltradas();
  }

  private agendeAtualizacaoLinhasFiltradas(): void {
    if (this.atualizacaoLinhasTimer)
      clearTimeout(this.atualizacaoLinhasTimer);
    this.recalculandoLinhas = true;
    this.atualizacaoLinhasTimer = setTimeout(() => {
      this.atualizeLinhasFiltradas();
      this.recalculandoLinhas = false;
    }, 0);
  }

  private atualizePaginacaoLinhasFiltradas(): void {
    const inicio = (this.paginaAtual - 1) * this.itensPorPagina;
    this.linhasFiltradasPaginadasCache = this.linhasFiltradasCache.slice(inicio, inicio + this.itensPorPagina);
    this.inicioExibicaoCache = this.linhasFiltradasCache.length ? inicio + 1 : 0;
    this.fimExibicaoCache = Math.min(this.paginaAtual * this.itensPorPagina, this.linhasFiltradasCache.length);
  }

  private atualizeIndiceGruposAdicionais(): void {
    this.grupoAdicionalIndice = new Map<string, number>();
    this.totalAdicionaisPorProduto = new Map<number, number>();
    this.linhasCatalogo
      .filter((linha) => linha.tipoAlvo === 'OPCAO_ADICIONAL' && !!linha.grupoAdicionalKey)
      .forEach((linha) => {
        if (!this.grupoAdicionalIndice.has(linha.grupoAdicionalKey))
          this.grupoAdicionalIndice.set(linha.grupoAdicionalKey, this.grupoAdicionalIndice.size);
        if (linha.produtoId)
          this.totalAdicionaisPorProduto.set(
            Number(linha.produtoId),
            (this.totalAdicionaisPorProduto.get(Number(linha.produtoId)) || 0) + 1
          );
      });
  }

  private obtenhaDisponibilidadesTabela(tabela: PriceTableVM): any[] {
    return (tabela?.disponibilidades || [])
      .map((disponibilidade: any) => {
        const id = Number(disponibilidade?.id || disponibilidade);
        return (this.empresa?.catalogo?.disponibilidades || [])
          .find((item: any) => Number(item.id) === id) || disponibilidade;
      })
      .filter((disponibilidade: any) => !!disponibilidade);
  }

  private disponibilidadeEstaDisponivelAgora(disponibilidade: any): boolean {
    const agora = new Date();
    if (!this.dataNoIntervalo(disponibilidade, agora)) return false;

    const periodos = disponibilidade?.periodos || [];
    if (!periodos.length) return true;

    return periodos.some((periodo: any) => this.periodoEstaDisponivelAgora(periodo, agora));
  }

  private dataNoIntervalo(disponibilidade: any, agora: Date): boolean {
    const dataInicio = this.parseData(disponibilidade?.dataInicio);
    const dataFim = this.parseData(disponibilidade?.dataFim);
    const hoje = new Date(agora.getFullYear(), agora.getMonth(), agora.getDate());

    if (dataInicio && hoje < dataInicio) return false;
    if (dataFim && hoje > dataFim) return false;
    return true;
  }

  private parseData(valor: any): Date | null {
    if (!valor) return null;
    if (valor instanceof Date) return new Date(valor.getFullYear(), valor.getMonth(), valor.getDate());

    const dataIso = String(valor).match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (dataIso)
      return new Date(Number(dataIso[1]), Number(dataIso[2]) - 1, Number(dataIso[3]));

    const data = new Date(valor);
    if (isNaN(data.getTime())) return null;
    return new Date(data.getFullYear(), data.getMonth(), data.getDate());
  }

  private periodoEstaDisponivelAgora(periodo: any, agora: Date): boolean {
    const dias = periodo?.dias || [];
    const diaAtual = agora.getDay();
    const disponivelNoDia = dias.some((dia: any) => Number(dia?.dia ?? dia) === diaAtual);
    if (!disponivelNoDia) return false;
    if (!periodo.horaInicio || !periodo.horaFim) return true;

    const minutosAgora = agora.getHours() * 60 + agora.getMinutes();
    const inicio = this.horarioParaMinutos(periodo.horaInicio);
    const fim = this.horarioParaMinutos(periodo.horaFim);

    return inicio != null && fim != null && inicio <= minutosAgora && minutosAgora <= fim;
  }

  private horarioParaMinutos(valor: any): number | null {
    if (!valor) return null;
    if (valor instanceof Date) return valor.getHours() * 60 + valor.getMinutes();

    const partes = String(valor).split(':');
    const hora = Number(partes[0]);
    const minuto = Number(partes[1] || 0);
    if (isNaN(hora) || isNaN(minuto)) return null;
    return hora * 60 + minuto;
  }

  private montePreviewCopia(): CopyPricePreviewLineVM[] {
    const itens = this.monteItensParaCopia();
    return itens
      .map((item) => {
        const linha = this.linhasCatalogo.find((linhaCatalogo) =>
          linhaCatalogo.tipoAlvo === item.tipoAlvo && Number(linhaCatalogo.alvoId) === Number(item.alvoId)
        );
        if (!linha) return null;
        return {
          linha,
          valorAtual: linha.item.valor,
          valorOrigem: this.obtenhaValorOrigemCopia(linha, item, 'valor'),
          valorNovo: item.valor,
          valorAtacadoAtual: linha.item.valorAtacado,
          valorAtacadoOrigem: this.obtenhaValorOrigemCopia(linha, item, 'valorAtacado'),
          valorAtacadoNovo: item.valorAtacado,
          quantidadeAtual: linha.item.quantidadeMinimaAtacado,
          quantidadeNova: item.quantidadeMinimaAtacado
        };
      })
      .filter((item) => !!item) as CopyPricePreviewLineVM[];
  }

  private async apliqueValoresIniciaisTabelaCriada(
    tabela: PriceTableVM,
    modo: InitialPriceSeedMode,
    tabelaOrigemId: number | null
  ): Promise<void> {
    if (!tabela.id || modo === 'VAZIA') return;

    if (modo === 'PADRAO_PRODUTOS') {
      const itens = this.linhasCatalogo
        .filter((linha) =>
          (linha.tipoAlvo === 'PRODUTO' || linha.tipoAlvo === 'PRODUTO_TAMANHO')
          && linha.precoPadrao != null
        )
        .map((linha) => ({
          tabelaDePrecosId: tabela.id!,
          tipoAlvo: linha.tipoAlvo,
          alvoId: linha.alvoId,
          precoPadrao: linha.precoPadrao
        }));

      if (!itens.length) return;
      await this.tabelaPrecosService.apliquePrecosPadrao(tabela.id, itens);
      await this.carregueItensTabela();
      return;
    }

    if (!tabelaOrigemId) return;
    const itensOrigem = await this.tabelaPrecosService.listeItens(tabelaOrigemId);
    const itens = (itensOrigem || []).map((item) => ({
      tabelaDePrecosId: tabela.id!,
      tipoAlvo: item.tipoAlvo,
      alvoId: item.alvoId,
      valor: item.valor,
      desconto: item.desconto,
      valorAtacado: tabela.suportaPrecosAtacado ? item.valorAtacado : null,
      quantidadeMinimaAtacado: tabela.suportaPrecosAtacado ? item.quantidadeMinimaAtacado : null
    }));

    if (!itens.length) return;
    await this.tabelaPrecosService.salveItens(tabela.id, itens);
    await this.carregueItensTabela();
  }

  private monteItensParaCopia(): PriceTableItemVM[] {
    const tabelaDePrecosId = this.tabelaSelecionada?.id;
    if (!tabelaDePrecosId) return [];
    if (this.copiaOrigemTipo === 'TABELA' && !this.copiaOrigemTabelaId) return [];

    const origemPorAlvo = new Map<string, PriceTableItemVM>();
    this.copiaOrigemItens.forEach((item) => origemPorAlvo.set(this.chaveItemPreco(item.tipoAlvo, item.alvoId), item));

    return this.linhasCatalogo
      .map((linha) => {
        const item = {
          ...linha.item,
          tabelaDePrecosId,
          tipoAlvo: linha.tipoAlvo,
          alvoId: linha.alvoId
        };
        let alterado = false;

        if (this.copiaOrigemTipo === 'PADRAO') {
          if (this.copiaPrecoUnitario && linha.precoPadrao != null) {
            item.valor = this.apliqueAjustePreco(linha.precoPadrao);
            item.desconto = null;
            alterado = true;
          }
        } else {
          const origem = origemPorAlvo.get(this.chaveItemPreco(linha.tipoAlvo, linha.alvoId));
          if (origem) {
            if (this.copiaPrecoUnitario && origem.valor != null) {
              item.valor = this.apliqueAjustePreco(origem.valor);
              item.desconto = this.possuiAjusteCopia() ? null : origem.desconto;
              alterado = true;
            }
            if (this.copiaPrecoAtacado && this.podeCopiarAtacado && origem.valorAtacado != null) {
              if (Number(origem.quantidadeMinimaAtacado || 0) > 1) {
                item.valorAtacado = this.apliqueAjustePreco(origem.valorAtacado);
                item.quantidadeMinimaAtacado = origem.quantidadeMinimaAtacado;
                alterado = true;
              }
            }
          }
        }

        return alterado ? item : null;
      })
      .filter((item) => !!item) as PriceTableItemVM[];
  }

  private obtenhaValorOrigemCopia(linha: PriceTableLineVM, item: PriceTableItemVM, campo: 'valor' | 'valorAtacado'): number | null {
    if (this.copiaOrigemTipo === 'PADRAO') {
      return campo === 'valor' ? linha.precoPadrao : null;
    }

    const origem = this.copiaOrigemItens.find((origemItem) =>
      origemItem.tipoAlvo === item.tipoAlvo && Number(origemItem.alvoId) === Number(item.alvoId)
    );
    const valor = origem ? origem[campo] : null;
    return valor == null ? null : Number(valor);
  }

  private apliqueAjustePreco(valor: number): number {
    const preco = Number(valor);
    if (isNaN(preco)) return valor;

    const ajuste = Number(this.copiaAjusteValor || 0);
    if (!ajuste) return Number(preco.toFixed(2));

    const delta = this.copiaAjusteTipo === 'PERCENTUAL'
      ? preco * (ajuste / 100)
      : ajuste;
    const ajustado = this.copiaAjusteOperacao === 'AUMENTAR'
      ? preco + delta
      : preco - delta;

    return Number(Math.max(0, ajustado).toFixed(2));
  }

  private possuiAjusteCopia(): boolean {
    return Number(this.copiaAjusteValor || 0) > 0;
  }

  private chaveItemPreco(tipoAlvo: PriceTableTargetTypeV2, alvoId: number): string {
    return `${tipoAlvo}:${Number(alvoId)}`;
  }

  private indiceGrupoAdicional(grupoKey: string): number {
    return this.linhasCatalogo
      .filter((linha) => linha.tipoAlvo === 'OPCAO_ADICIONAL' && !!linha.grupoAdicionalKey)
      .map((linha) => linha.grupoAdicionalKey)
      .filter((key, index, keys) => keys.indexOf(key) === index)
      .indexOf(grupoKey);
  }

  private monteLinhasCatalogo(produtos: ProductCatalogItemVM[]): any[] {
    const linhas: any[] = [];
    produtos.forEach((produto) => {
      if (!produto.id) return;
      if (!this.produtoEhPizza(produto)) {
        linhas.push(this.crieLinha(
          produto.id,
          'PRODUTO',
          produto.name,
          'Produto',
          produto.basePrice,
          produto.raw?.codigoPdv || '',
          produto.categoryId,
          this.obtenhaNomeCategoria(produto),
          produto.id,
          produto.name,
          produto.name,
          '',
          produto.image,
          produto.placeholderToken || this.criePlaceholder(produto.name)
        ));
      }
      (produto.raw?.tamanhos || []).forEach((tamanho: any) => {
        if (tamanho?.id) linhas.push(this.crieLinha(
          tamanho.id,
          'PRODUTO_TAMANHO',
          `${produto.name} / ${tamanho.template?.nome || tamanho.nome || tamanho.descricao || 'Tamanho'}`,
          'Tamanho',
          this.obtenhaPrecoPadrao(tamanho),
          tamanho.codigoPdv || produto.raw?.codigoPdv || '',
          produto.categoryId,
          this.obtenhaNomeCategoria(produto),
          produto.id,
          produto.name,
          `${produto.name} / ${tamanho.template?.nome || tamanho.nome || tamanho.descricao || 'Tamanho'}`,
          '',
          produto.image,
          produto.placeholderToken || this.criePlaceholder(produto.name)
        ));
      });
      (produto.raw?.camposAdicionais || []).forEach((grupo: any) => {
        (grupo.opcoesDisponiveis || []).forEach((opcao: any) => {
          if (opcao?.id) linhas.push(this.crieLinha(
            opcao.id,
            'OPCAO_ADICIONAL',
            `${grupo.nome}: ${opcao.nome}`,
            'Adicional',
            this.obtenhaPrecoPadrao(opcao),
            opcao.codigoPdv || '',
            produto.categoryId,
            this.obtenhaNomeCategoria(produto),
            produto.id,
            produto.name,
            `${grupo.nome}: ${opcao.nome}`,
            `${produto.id}:${grupo.id || grupo.nome}`,
            this.resolveImagemOpcao(opcao) || produto.image,
            this.criePlaceholder(opcao.nome || produto.name)
          ));
        });
      });
    });
    return linhas;
  }

  private crieLinha(
    alvoId: number,
    tipoAlvo: PriceTableTargetTypeV2,
    nome: string,
    tipoLabel: string,
    precoPadrao: number | null,
    codigoPdv: string,
    categoriaId: number | null,
    categoriaNome: string,
    produtoId: number | null,
    produtoNome: string,
    adicionalNome: string,
    grupoAdicionalKey: string,
    imagem: string | null,
    placeholderToken: string
  ): PriceTableLineVM {
    const existente = this.itensTabela.find((item) => item.tipoAlvo === tipoAlvo && Number(item.alvoId) === Number(alvoId));
    return {
      alvoId,
      tipoAlvo,
      nome,
      tipoLabel,
      precoPadrao,
      codigoPdv,
      categoriaId,
      categoriaNome,
      produtoId,
      produtoNome,
      adicionalNome,
      grupoAdicionalKey,
      imagem,
      placeholderToken,
      item: existente || {
        tabelaDePrecosId: this.tabelaSelecionada!.id!,
        tipoAlvo,
        alvoId,
        valor: null,
        desconto: null,
        valorAtacado: null,
        quantidadeMinimaAtacado: null
      }
    };
  }

  private obtenhaPrecoPadrao(alvo: any): number | null {
    const valor = alvo?.novoPreco ?? alvo?.valor ?? alvo?.preco;
    if (valor === null || valor === undefined || valor === '') return null;
    const numero = Number(valor);
    return isNaN(numero) ? null : numero;
  }

  private produtoEhPizza(produto: ProductCatalogItemVM): boolean {
    return produto?.type === 'pizza' || produto?.raw?.tipo === 'pizza';
  }

  private obtenhaNomeCategoria(produto: ProductCatalogItemVM): string {
    return produto.category || produto.categoryName || produto.raw?.categoria?.nome || 'Sem categoria';
  }

  private resolveImagemOpcao(opcao: any): string | null {
    const linkImagem = opcao?.imagens?.[0]?.linkImagem || opcao?.linkImagem || opcao?.imagem;
    if (!linkImagem) return null;
    if (/^https?:\/\//.test(linkImagem) || String(linkImagem).startsWith('/')) return linkImagem;
    return `/images/empresa/${String(linkImagem).replace(/^\/+/, '')}`;
  }

  private criePlaceholder(nome: string): string {
    return String(nome || '?').trim().charAt(0).toUpperCase() || '?';
  }

  private temValor(valor: any): boolean {
    return valor !== null && valor !== undefined && valor !== '';
  }
}
